<template>
  <div>
    <h1>Seguimiento de paquetes</h1>

    <status-filter @change="getpackages"></status-filter>

    <table-actions
      :tableHeaders="headers"
      :tableData="packages"
      :title="title"
      :showSelect="false"
      :showSubSelect="false"
      :showSubTable="true"
      :subTableHeaders="subtableHeaders"
      @aproved="aprovedPackage"
      @addPayment="addPayment"
    ></table-actions>

    <simple-modal v-if="showDialog" @close="showDialog = false">
      <add-payment :package="packageId" @success="success"></add-payment>
    </simple-modal>
  </div>
</template>

<script>
import ExtranetService from "../../services/extranet";

import AddPayment from "./AddPayment";
import StatusFilter from "./StatusFilter";
import TableActions from "./TableActions";

export default {
  name: "PackageTracking",
  components: { StatusFilter, TableActions, AddPayment },
  data() {
    return {
      packages: [],
      status: "to-authorize",
      packageId: 0,
      showDialog: false,
      subtableHeaders: [
        { text: "Número de siniestro", value: "sinisterNumber" },
        { text: "Número de requisición", value: "requisitionNumber" },
        { text: "Cliente", value: "highway" },
        { text: "Total", value: "total" },
      ],
    };
  },
  computed: {
    headers() {
      if (this.status === "to-authorize" || this.status === "redy-for-custom") {
        return [
          { text: "Folio", value: "folio" },
          { text: "Estatus", value: "name" },
          { text: "Fecha de envío", value: "addDate" },
          { text: "Tiempo transcurrido", value: "validationDate" },
          { text: "Siniestros", value: "sinisters" },
          { text: "Total", value: "total" },
          { text: "Total USD", value: "totalUSD" },
        ];
      } else if (this.status === "authorized") {
        return [
          { text: "Folio", value: "folio" },
          { text: "Estatus", value: "name" },
          { text: "Fecha de envío", value: "addDate" },
          { text: "Fecha de autorización", value: "validationDate" },
          { text: "Días transcurridos", value: "validationTime" },
          { text: "Siniestros", value: "sinisters" },
          { text: "Total", value: "total" },
          { text: "Total USD", value: "totalUSD" },
          { text: "Total pagado", value: "totalPayments" },
        ];
      }
      return [
        { text: "Folio", value: "folio" },
        { text: "Estatus", value: "name" },
        { text: "Fecha de envío", value: "addDate" },
        { text: "Fecha de autorización", value: "validationDate" },
        { text: "Días transcurridos", value: "validationTime" },
        { text: "Siniestros", value: "sinisters" },
        { text: "Total", value: "total" },
        { text: "Total USD", value: "totalUSD" },
      ];
    },
    title() {
      if (this.status == "to-authorize") {
        return "Paquetes";
      } else if (this.status == "authorized") {
        return "Autorizados";
      } else if (this.status == "redy-for-custom") {
        return "Visibles para el cliente";
      }
    },
  },
  mounted() {
    ExtranetService.fetchPackages().then((response) => {
      this.packages = response;
    });
  },
  methods: {
    getpackages(value) {
      this.status = value.status;
      ExtranetService.fetchPackages(value).then((response) => {
        this.packages = response;
      });
    },
    aprovedPackage(packageId) {
      this.getpackages({ status: this.status });
    },
    addPayment(packageId) {
      this.packageId = packageId;
      this.showDialog = true;
    },
    success() {
      this.showDialog = false;
      this.$successMessage({
        title: "Depósito registrado",
        text: "El depósito se registro exitosamente",
      });
      this.getpackages({ status: this.status });
    },
  },
};
</script>

<style lang="scss" scoped>
.md-card {
  z-index: unset;
}
</style>


// WEBPACK FOOTER //
// src/pages/extranet/PackageTracking.vue